import { render } from "./FourZeroThreeComponent.vue?vue&type=template&id=38b8ded5"
import script from "./FourZeroThreeComponent.vue?vue&type=script&lang=js"
export * from "./FourZeroThreeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__